import Content from "uxp-documentation/src/pages/uxp-api/reference-spectrum/User Interface/sp-radio";
import * as React from 'react';
export default {
  Content,
  React
};